import request from "@/utils/request";

export function getTagList(params) {
  return request({
    url: "/tag/queryPage",
    method: "post",
    data: params
  });
}

export function getAllTagList() {
  return request({
    url: "/tag/queryAll",
    method: "post"
  });
}



// WEBPACK FOOTER //
// ./src/api/tag.js